// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import GlobalStyles from '../../../../../../../../config/styles';


const styles = theme => ({
  container: {
    width: 400,
    padding: 10,
    display: 'flex',
    borderRadius: 10,
    justifyContent: 'space-between',
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,

    [theme.breakpoints.down(450)]: {
      textAlign: 'center',
      flexDirection: 'column-reverse',
      width: '100%',
    },
  },
  imageContainer: {
    margin: '0 20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.breakpoints.down(450)]: {
      margin: '20px 0',
      width: '100%',
    },
  },
  image: {
    height: 45,
  },
  mainText: {
    color: GlobalStyles.color.COLOR_BLUE,
    fontSize: GlobalStyles.fonts.FONT_SIZE,

    '&:hover': {
      textDecoration: 'none',
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column'
  },
  textDescription: {
    color: GlobalStyles.color.COLOR_BLACK_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_MINI,
  }
});

export default styles;
